import { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import CustomCard from "../../../components/common/customCard";

class Circuit_HajjOmra extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <Container>
            <br /><br />
            <center>Vous aimerez:</center>
            <br />
            <Col>
          <div className="custom-card mx-5">
                <Row className="mx-5">
                  <CustomCard
                    IdSpe="hg-ctrl-voy"
                    size={6}
                    imgPath={"/imgs/cirucuitsChoice/mondialCircuit.png"}
                    linkPath={"/"}
                    title={"Omra Organisé (Agence)"}
                    paddingCost={"0 5px 0 15px"}
                  />
                  <CustomCard
                    IdSpe="hg-ctrl-voy"
                    size={6}
                    imgPath={"/imgs/cirucuitsChoice/haje.png"}
                    linkPath={"/voyages/haj_omra_circuit/offres_hajj/mon_voyage"}
                    title={"Organiser Votre Voy Vous-méme"}
                    paddingCost={"0 15px 0 5px"}
                  />
                </Row>
                <Row className="mx-5" style={{marginTop:"-10px"}}>
                  <CustomCard
                    IdSpe="hg-ctrl-voy"
                    size={6}
                    imgPath={"/imgs/cirucuitsChoice/mondialCircuit.png"}
                    linkPath={"/voyages/haj_omra_circuit/offres_hajj"}
                    title={"Offres Hajj"}
                    paddingCost={"0 5px 0 15px"}
                  />
                  <CustomCard
                    IdSpe="hg-ctrl-voy"
                    size={6}
                    imgPath={"/imgs/cirucuitsChoice/haje.png"}
                    linkPath={"/"}
                    title={"Voir les Offres du Ramdan"}
                    paddingCost={"0 10px 0 5px"}
                  />
                </Row>
              </div>
              </Col>
              </Container>

         );
    }
}
 
export default Circuit_HajjOmra;